import React from "react";
import { Star } from "lucide-react";

interface StarRatingProps {
  rating: number;
  onRatingChange: (rating: number) => void;
  size?: number;
  className?: string;
}

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  onRatingChange,
  size = 24,
  className = "",
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      {[...Array(5)].map((_, index) => {
        const starValue = index + 1;
        return (
          <Star
            key={index}
            size={size}
            className={
              `cursor-pointer ` +
              (starValue <= rating
                ? "text-yellow-400 fill-yellow-400"
                : "text-gray-300")
            }
            onClick={() => onRatingChange(starValue)}
          />
        );
      })}
    </div>
  );
};
